import About from './about/About';
import Home from './home/Home';
import Services from './services/Services';
import Contacts from './contacts/Contacts';
import ServiceDetails from './service-details/ServiceDetails';
import Events from './events/Events';
import EventDetails from './event-details/EventDetails';
import News from './news';

export { About, Home, Contacts, Services, ServiceDetails, Events, EventDetails, News};



// WEBPACK FOOTER //
// ./src/containers/index.js